/** Shell breakpoint (CSS px): below it the side menu becomes an overlay. */
export const COMPACT_LAYOUT_MAX_WIDTH = 1280;

/** Viewport height (CSS px) from which page-level grids show more rows. */
const TALL_VIEWPORT_MIN_HEIGHT = 1000;

/**
 * Page size for page-level grids: tall screens (large monitors, including 4K
 * at 150% OS scaling) show 20 rows instead of leaving most of the screen empty.
 */
export function adaptivePageSize(base: number): number {
  return typeof window !== 'undefined' && window.innerHeight >= TALL_VIEWPORT_MIN_HEIGHT ? Math.max(base, 20) : base;
}
